import { addDays, format, startOfWeek } from 'date-fns';
import { DayOfWeekEnum } from 'types/generated/client';

/** Sunday-first, matching the `day_of_week` table's own ordering. */
const DAY_INDEX: Record<DayOfWeekEnum, number> = {
  [DayOfWeekEnum.Sunday]: 0,
  [DayOfWeekEnum.Monday]: 1,
  [DayOfWeekEnum.Tuesday]: 2,
  [DayOfWeekEnum.Wednesday]: 3,
  [DayOfWeekEnum.Thursday]: 4,
  [DayOfWeekEnum.Friday]: 5,
  [DayOfWeekEnum.Saturday]: 6,
};

/** An arbitrary date falling on the given day, so date-fns can name it. */
const dateForDayOfWeek = (day: DayOfWeekEnum) =>
  addDays(startOfWeek(new Date(2000, 0, 2)), DAY_INDEX[day]);

/** Rendered order for anything iterating the week — Sunday first. */
export const DAYS_OF_WEEK_IN_ORDER = Object.values(DayOfWeekEnum).sort(
  (left, right) => DAY_INDEX[left] - DAY_INDEX[right],
);

/** "Monday" */
export const dayOfWeekLabel = (day: DayOfWeekEnum) => format(dateForDayOfWeek(day), 'EEEE');

/** "Mondays" — day chips that describe a recurring habit rather than a date. */
export const dayOfWeekPluralLabel = (day: DayOfWeekEnum) => `${dayOfWeekLabel(day)}s`;

/** "Mon" */
export const dayOfWeekShortLabel = (day: DayOfWeekEnum) => format(dateForDayOfWeek(day), 'EEE');
